module.exports = __webpack_public_path__ + "img/banner-avatar.26f44378.png";